import { _mock } from "./_mock";

// ----------------------------------------------------------------------

export const _carouselsMembers = [...Array(6)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.fullName(index),
  role: _mock.role(index),
  avatarUrl: _mock.image.portrait(index),
}));

// ----------------------------------------------------------------------

export const _faqs = [...Array(8)].map((_, index) => ({
  id: _mock.id(index),
  value: `panel${index + 1}`,
  heading: `Questions ${index + 1}`,
  detail: _mock.description(index),
}));

// ----------------------------------------------------------------------

export const _addressBooks = [...Array(24)].map((_, index) => ({
  id: Math.floor(Math.random() * 100),
  primary: index === 0,
  fullname: _mock.fullName(index),
  email: _mock.email(index + 1),
  fullAddress: _mock.fullAddress(index),
  phoneNumber: _mock.phoneNumber(index),
  company: _mock.companyName(index + 1),
  addressType: index === 0 ? "personal" : "business",
  billing_type: "personal",
  country: "hu",
  city: "dfdf",
  street: "Zala",
  housenumber: "12",
  zipcode: "2231",
}));

// ----------------------------------------------------------------------

export const _contacts = [...Array(20)].map((_, index) => {
  const status =
    (index % 2 && "online") ||
    (index % 3 && "offline") ||
    (index % 4 && "alway") ||
    "busy";

  return {
    id: _mock.id(index),
    status,
    role: _mock.role(index),
    email: _mock.email(index),
    name: _mock.fullName(index),
    phoneNumber: _mock.phoneNumber(index),
    lastActivity: _mock.time(index),
    avatarUrl: _mock.image.avatar(index),
    address: _mock.fullAddress(index),
  };
});

// ----------------------------------------------------------------------
export const _notifications = [...Array(1)].map((_, index) => ({
  id: _mock.id(index),
  avatarUrl: [_mock.image.avatar(1)][index],
  type: ["chat"][index],
  category: ["Communication"][index],
  isUnRead: _mock.boolean(index),
  createdAt: _mock.time(index),
  title: (index === 0 && `<p>You have new message</p>`) || "",
}));

// export const _notifications = [...Array(15)].map((_, index) => ({
//   id: _mock.id(index),
//   avatarUrl: [
//     _mock.image.avatar(1),
//     _mock.image.avatar(2),
//     _mock.image.avatar(3),
//     _mock.image.avatar(4),
//     _mock.image.avatar(5),
//     null,
//     null,
//     null,
//     null,
//     null,
//     _mock.image.avatar(1),
//     _mock.image.avatar(2),
//     _mock.image.avatar(3),
//     _mock.image.avatar(4),
//     _mock.image.avatar(5),
//     null,
//     null,
//     null,
//     null,
//     null,
//   ][index],
//   type: [
//     "friend",
//     "project",
//     "file",
//     "tags",
//     "payment",
//     "order",
//     "chat",
//     "mail",
//     "delivery",
//     "friend",
//     "project",
//     "file",
//     "tags",
//     "payment",
//     "order",
//     "chat",
//     "mail",
//     "delivery",
//   ][index],
//   category: [
//     "Communication",
//     "Project UI",
//     "File Manager",
//     "File Manager",
//     "File Manager",
//     "Order",
//     "Order",
//     "Communication",
//     "Communication",
//     "Communication",
//     "Project UI",
//     "File Manager",
//     "File Manager",
//     "File Manager",
//     "Order",
//     "Order",
//     "Communication",
//     "Communication",
//   ][index],
//   isUnRead: _mock.boolean(index),
//   createdAt: _mock.time(index),
//   title:
//     (index === 0 &&
//       `<p><strong>Deja Brady</strong> sent you a friend request</p>`) ||
//     (index === 1 &&
//       `<p><strong>Jayvon Hull</strong> mentioned you in <strong><a href='#'>Minimal UI</a></strong></p>`) ||
//     (index === 2 &&
//       `<p><strong>Lainey Davidson</strong> added file to <strong><a href='#'>File Manager</a></strong></p>`) ||
//     (index === 3 &&
//       `<p><strong>Angelique Morse</strong> added new tags to <strong><a href='#'>File Manager<a/></strong></p>`) ||
//     (index === 4 &&
//       `<p><strong>Giana Brandt</strong> request a payment of <strong>$200</strong></p>`) ||
//     (index === 5 && `<p>Your order is placed waiting for shipping</p>`) ||
//     (index === 6 && `<p>Delivery processing your order is being shipped</p>`) ||
//     (index === 7 && `<p>You have new message 5 unread messages</p>`) ||
//     (index === 8 && `<p>You have new mail`) ||
//     (index === 9 &&
//       `<p><strong>Deja Brady</strong> sent you a friend request</p>`) ||
//     (index === 10 &&
//       `<p><strong>Jayvon Hull</strong> mentioned you in <strong><a href='#'>Minimal UI</a></strong></p>`) ||
//     (index === 11 &&
//       `<p><strong>Lainey Davidson</strong> added file to <strong><a href='#'>File Manager</a></strong></p>`) ||
//     (index === 12 &&
//       `<p><strong>Angelique Morse</strong> added new tags to <strong><a href='#'>File Manager<a/></strong></p>`) ||
//     (index === 13 &&
//       `<p><strong>Giana Brandt</strong> request a payment of <strong>$200</strong></p>`) ||
//     (index === 14 && `<p>Your order is placed waiting for shipping</p>`) ||
//     (index === 15 &&
//       `<p>Delivery processing your order is being shipped</p>`) ||
//     (index === 16 && `<p>You have new message 5 unread messages</p>`) ||
//     (index === 17 && `<p>You have new mail`) ||
//     "",
// }));

// ----------------------------------------------------------------------

export const _mapContact = [
  {
    latlng: [33, 65],
    address: _mock.fullAddress(1),
    phoneNumber: _mock.phoneNumber(1),
  },
  {
    latlng: [-12.5, 18.5],
    address: _mock.fullAddress(2),
    phoneNumber: _mock.phoneNumber(2),
  },
];

// ----------------------------------------------------------------------

export const _socials = [
  {
    value: "facebook",
    name: "FaceBook",
    icon: "eva:facebook-fill",
    color: "#1877F2",
    path: "https://www.facebook.com/caitlyn.kerluke",
  },
  {
    value: "instagram",
    name: "Instagram",
    icon: "ant-design:instagram-filled",
    color: "#E02D69",
    path: "https://www.instagram.com/caitlyn.kerluke",
  },
  {
    value: "linkedin",
    name: "Linkedin",
    icon: "eva:linkedin-fill",
    color: "#007EBB",
    path: "https://www.linkedin.com/caitlyn.kerluke",
  },
  {
    value: "twitter",
    name: "Twitter",
    icon: "eva:twitter-fill",
    color: "#00AAEC",
    path: "https://www.twitter.com/caitlyn.kerluke",
  },
];

// ----------------------------------------------------------------------

export const _homePlans = [...Array(3)].map((_, index) => ({
  license: ["Standard", "Standard Plus", "Extended"][index],
  commons: ["One end products", "12 months updates", "6 months of support"],
  options: [
    "JavaScript version",
    "TypeScript version",
    "Design Resources",
    "Commercial applications",
  ],
  icons: [
    "/assets/icons/platforms/ic_js.svg",
    "/assets/icons/platforms/ic_ts.svg",
    "/assets/icons/platforms/ic_figma.svg",
  ],
}));

// ----------------------------------------------------------------------

export const _pricingPlans = [
  {
    subscription: "basic",
    price: 0,
    caption: "Forever",
    lists: ["3 Prototypes", "3 Boards", "Up To 5 Team Members"],
    labelAction: "Current Plan",
  },
  {
    subscription: "starter",
    price: 4.99,
    caption: "Saving $24 a year",
    lists: [
      "3 Prototypes",
      "3 Boards",
      "Up To 5 Team Members",
      "Advanced Security",
      "Issue Escalation",
    ],
    labelAction: "Choose Starter",
  },
  {
    subscription: "premium",
    price: 9.99,
    caption: "Saving $124 a year",
    lists: [
      "3 Prototypes",
      "3 Boards",
      "Up To 5 Team Members",
      "Advanced Security",
      "Issue Escalation",
      "Issue Development license",
      "Permissions & workflows",
    ],
    labelAction: "Choose Premium",
  },
];

// ----------------------------------------------------------------------

export const _testimonials = [
  {
    name: _mock.fullName(1),
    postedDate: _mock.time(1),
    ratingNumber: _mock.number.rating(1),
    avatarUrl: _mock.image.avatar(1),
    content: `Excellent Work! Thanks a lot!`,
  },
  {
    name: _mock.fullName(2),
    postedDate: _mock.time(2),
    ratingNumber: _mock.number.rating(2),
    avatarUrl: _mock.image.avatar(2),
    content: `It's a very good dashboard and we are really liking the product . We've done some things, like migrate to TS and implementing a react useContext api, to fit our job methodology but the product is one of the best in terms of design and application architecture. The team did a really good job.`,
  },
  {
    name: _mock.fullName(3),
    postedDate: _mock.time(3),
    ratingNumber: _mock.number.rating(3),
    avatarUrl: _mock.image.avatar(3),
    content: `Customer support is realy fast and helpful the desgin of this theme is looks amazing also the code is very clean and readble realy good job !`,
  },
  {
    name: _mock.fullName(4),
    postedDate: _mock.time(4),
    ratingNumber: _mock.number.rating(4),
    avatarUrl: _mock.image.avatar(4),
    content: `Amazing, really good code quality and gives you a lot of examples for implementations.`,
  },
  // {
  //   name: _mock.fullName(5),
  //   postedDate: _mock.time(5),
  //   ratingNumber: _mock.number.rating(5),
  //   avatarUrl: _mock.image.avatar(5),
  //   content: `Got a few questions after purchasing the product. The owner responded very fast and very helpfull. Overall the code is excellent and works very good. 5/5 stars!`,
  // },
  // {
  //   name: _mock.fullName(6),
  //   postedDate: _mock.time(6),
  //   ratingNumber: _mock.number.rating(6),
  //   avatarUrl: _mock.image.avatar(6),
  //   content: `CEO of Codealy.io here. We’ve built a developer assessment platform that makes sense - tasks are based on git repositories and run in virtual machines. We automate the pain points - storing candidates code, running it and sharing test results with the whole team, remotely. Bought this template as we need to provide an awesome dashboard for our early customers. I am super happy with purchase. The code is just as good as the design. Thanks!`,
  // },
];

export const _conversations = [
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
        role: "Data Analyst",
        email: "ashlynn_ohara62@gmail.com",
        name: "Lucian Obrien",
        lastActivity: "2024-06-05T10:52:14.377Z",
        address: "1147 Rohan Drive Suite 819 - Burlington, VT / 82021",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_2.jpg",
        phoneNumber: "904-966-2836",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "e3f2c243-f919-47aa-9432-cddd8f8bbc50",
        body: "She eagerly opened the gift, her eyes sparkling with excitement.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
            name: "cover-2.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_3.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_3.jpg",
            size: 48000000,
            createdAt: "2024-06-06T11:51:11.098Z",
            modifiedAt: "2024-06-06T11:51:11.098Z",
            type: "jpg",
          },
        ],
        createdAt: "2024-06-06T01:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
      },
      {
        id: "04845735-ee49-4a96-a841-e200ad4d6b02",
        body: "The old oak tree stood tall and majestic, its branches swaying gently in the breeze.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
            name: "design-suriname-2015.mp3",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/design_suriname_2015.mp3",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/design_suriname_2015.mp3",
            size: 24000000,
            createdAt: "2024-06-05T10:51:11.098Z",
            modifiedAt: "2024-06-05T10:51:11.098Z",
            type: "mp3",
          },
        ],
        createdAt: "2024-06-06T09:52:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "f7169cb6-5c25-4973-8c14-03c2665f4b6f",
        body: "The aroma of freshly brewed coffee filled the air, awakening my senses.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
            name: "expertise-2015-conakry-sao-tome-and-principe-gender.mp4",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/expertise_2015_conakry_sao-tome-and-principe_gender.mp4",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/expertise_2015_conakry_sao-tome-and-principe_gender.mp4",
            size: 16000000,
            createdAt: "2024-06-04T09:51:11.098Z",
            modifiedAt: "2024-06-04T09:51:11.098Z",
            type: "mp4",
          },
        ],
        createdAt: "2024-06-06T11:44:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
      },
      {
        id: "daa90c40-c206-4da4-a294-48a1113daac5",
        body: "The children giggled with joy as they ran through the sprinklers on a hot summer day.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
            name: "money-popup-crack.pdf",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/money-popup-crack.pdf",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/money-popup-crack.pdf",
            size: 12000000,
            createdAt: "2024-06-03T08:51:11.098Z",
            modifiedAt: "2024-06-03T08:51:11.098Z",
            type: "pdf",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
            name: "cover-4.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_4.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_4.jpg",
            size: 9600000,
            createdAt: "2024-06-02T07:51:11.098Z",
            modifiedAt: "2024-06-02T07:51:11.098Z",
            type: "jpg",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
            name: "cover-6.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_6.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_6.jpg",
            size: 8000000,
            createdAt: "2024-06-01T06:51:11.098Z",
            modifiedAt: "2024-06-01T06:51:11.098Z",
            type: "jpg",
          },
        ],
        createdAt: "2024-06-06T11:46:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "0c8cd85b-d7c3-4cc1-a7f1-fd0920c13891",
        body: "He carefully crafted a beautiful sculpture out of clay, his hands skillfully shaping the intricate details.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
            name: "large-news.txt",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/large_news.txt",
            preview: "https://www.cloud.com/s/c218bo6kjuqyv66/large_news.txt",
            size: 6857142.857142857,
            createdAt: "2024-05-31T05:51:11.099Z",
            modifiedAt: "2024-05-31T05:51:11.099Z",
            type: "txt",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
            name: "nauru-6015-small-fighter-left-gender.psd",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/nauru-6015-small-fighter-left-gender.psd",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/nauru-6015-small-fighter-left-gender.psd",
            size: 6000000,
            createdAt: "2024-05-30T04:51:11.099Z",
            modifiedAt: "2024-05-30T04:51:11.099Z",
            type: "psd",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
            name: "tv-xs.doc",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/tv-xs.doc",
            preview: "https://www.cloud.com/s/c218bo6kjuqyv66/tv-xs.doc",
            size: 5333333.333333333,
            createdAt: "2024-05-29T03:51:11.099Z",
            modifiedAt: "2024-05-29T03:51:11.099Z",
            type: "doc",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
            name: "gustavia-entertainment-productivity.docx",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/gustavia-entertainment-productivity.docx",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/gustavia-entertainment-productivity.docx",
            size: 4800000,
            createdAt: "2024-05-28T02:51:11.099Z",
            modifiedAt: "2024-05-28T02:51:11.099Z",
            type: "docx",
          },
        ],
        createdAt: "2024-06-06T11:48:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
      },
      {
        id: "221efee0-a0b6-4b57-8dc1-e8fed945ae93",
        attachments: [],
        contentType: "image",
        body: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_5.jpg",
        createdAt: "2024-06-06T11:50:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
      },
      {
        id: "75e2d77f-3dcd-40d3-bf96-303f074e5fbe",
        contentType: "text",
        attachments: [],
        body: "The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.",
        createdAt: "2024-06-06T11:50:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "fde1812d-6cac-44c2-9465-d0a674aae5fb",
        body: "The waves crashed against the shore, creating a soothing symphony of sound.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:50:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "offline",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
        role: "Legal Counsel",
        email: "milo.farrell@hotmail.com",
        name: "Deja Brady",
        lastActivity: "2024-06-04T09:52:14.377Z",
        address: "18605 Thompson Circle Apt. 086 - Idaho Falls, WV / 50337",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_3.jpg",
        phoneNumber: "399-757-9909",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "e3efd5d4-e7a8-45aa-8670-0dfa3025418f",
        body: "The old oak tree stood tall and majestic, its branches swaying gently in the breeze.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T03:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
      },
      {
        id: "d4166eb1-4a4e-421f-a537-5676aeec4c04",
        body: "The aroma of freshly brewed coffee filled the air, awakening my senses.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T05:52:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "0bf7bb52-9a76-484d-9887-5864a04c6438",
        body: "The children giggled with joy as they ran through the sprinklers on a hot summer day.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T07:22:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
      },
      {
        id: "2d890f9d-f6b7-4ba5-8d58-797a2b8686f8",
        body: "He carefully crafted a beautiful sculpture out of clay, his hands skillfully shaping the intricate details.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T09:37:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "5a694e92-5d76-4b9e-a500-1e035c068435",
        body: "The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T10:37:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
      },
      {
        id: "e17108ea-3014-46d7-bea0-8181a03e0e6e",
        body: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_8.jpg",
        attachments: [],
        contentType: "image",
        createdAt: "2024-06-06T10:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
      },
      {
        id: "d9a147a7-3be6-436d-9371-85a3f5bb8eb5",
        body: "The scent of blooming flowers wafted through the garden, creating a fragrant paradise.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:07:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
        role: "UX/UI Designer",
        email: "violet.ratke86@yahoo.com",
        name: "Harrison Stein",
        lastActivity: "2024-06-03T08:52:14.377Z",
        address: "110 Lamar Station Apt. 730 - Hagerstown, OK / 49808",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_4.jpg",
        phoneNumber: "692-767-2903",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "0b450b89-e324-4b20-a7d4-eea1be721de9",
        body: "The aroma of freshly brewed coffee filled the air, awakening my senses.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
            name: "cover-2.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_3.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_3.jpg",
            size: 48000000,
            createdAt: "2024-06-06T11:51:11.098Z",
            modifiedAt: "2024-06-06T11:51:11.098Z",
            type: "jpg",
          },
        ],
        createdAt: "2024-06-06T03:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
      },
      {
        id: "c7c14b11-833d-46dd-aa80-13eaf09a316c",
        body: "The children giggled with joy as they ran through the sprinklers on a hot summer day.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
            name: "design-suriname-2015.mp3",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/design_suriname_2015.mp3",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/design_suriname_2015.mp3",
            size: 24000000,
            createdAt: "2024-06-05T10:51:11.098Z",
            modifiedAt: "2024-06-05T10:51:11.098Z",
            type: "mp3",
          },
        ],
        createdAt: "2024-06-06T05:52:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "cc065481-49cd-429a-bc35-67e10bf75ede",
        body: "He carefully crafted a beautiful sculpture out of clay, his hands skillfully shaping the intricate details.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T07:22:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
      },
      {
        id: "e53a9467-bbff-4c7c-aa3b-3b3365977d40",
        body: "The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
            name: "expertise-2015-conakry-sao-tome-and-principe-gender.mp4",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/expertise_2015_conakry_sao-tome-and-principe_gender.mp4",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/expertise_2015_conakry_sao-tome-and-principe_gender.mp4",
            size: 16000000,
            createdAt: "2024-06-04T09:51:11.098Z",
            modifiedAt: "2024-06-04T09:51:11.098Z",
            type: "mp4",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
            name: "money-popup-crack.pdf",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/money-popup-crack.pdf",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/money-popup-crack.pdf",
            size: 12000000,
            createdAt: "2024-06-03T08:51:11.098Z",
            modifiedAt: "2024-06-03T08:51:11.098Z",
            type: "pdf",
          },
        ],
        createdAt: "2024-06-06T09:37:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "7fead40c-6792-4ba2-a7c8-03f1cf23c647",
        body: "The waves crashed against the shore, creating a soothing symphony of sound.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T10:37:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
      },
      {
        id: "65925d4d-c121-48bd-82b1-30ca7c5b1014",
        body: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_9.jpg",
        contentType: "image",
        attachments: [],
        createdAt: "2024-06-06T10:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
      },
      {
        id: "ff3f8b19-1fa3-415c-adc0-c5cfe457ee95",
        body: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_10.jpg",
        contentType: "image",
        attachments: [],
        createdAt: "2024-06-06T10:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "offline",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
        role: "Project Manager",
        email: "letha_lubowitz24@yahoo.com",
        name: "Reece Chung",
        lastActivity: "2024-06-02T07:52:14.377Z",
        address: "36901 Elmer Spurs Apt. 762 - Miramar, DE / 92836",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_5.jpg",
        phoneNumber: "990-588-5716",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 8,
    messages: [
      {
        id: "e4094481-47c9-47ff-8c19-ec9f47a0c8f0",
        body: "The children giggled with joy as they ran through the sprinklers on a hot summer day.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
            name: "expertise-2015-conakry-sao-tome-and-principe-gender.mp4",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/expertise_2015_conakry_sao-tome-and-principe_gender.mp4",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/expertise_2015_conakry_sao-tome-and-principe_gender.mp4",
            size: 16000000,
            createdAt: "2024-06-04T09:51:11.098Z",
            modifiedAt: "2024-06-04T09:51:11.098Z",
            type: "mp4",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
            name: "money-popup-crack.pdf",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/money-popup-crack.pdf",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/money-popup-crack.pdf",
            size: 12000000,
            createdAt: "2024-06-03T08:51:11.098Z",
            modifiedAt: "2024-06-03T08:51:11.098Z",
            type: "pdf",
          },
        ],
        createdAt: "2024-06-06T01:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
      },
      {
        id: "3295f7b0-19fc-43cd-bf9b-8c9d3b753ce4",
        body: "He carefully crafted a beautiful sculpture out of clay, his hands skillfully shaping the intricate details.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
            name: "cover-4.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_4.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_4.jpg",
            size: 9600000,
            createdAt: "2024-06-02T07:51:11.098Z",
            modifiedAt: "2024-06-02T07:51:11.098Z",
            type: "jpg",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
            name: "cover-6.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_6.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_6.jpg",
            size: 8000000,
            createdAt: "2024-06-01T06:51:11.098Z",
            modifiedAt: "2024-06-01T06:51:11.098Z",
            type: "jpg",
          },
        ],
        createdAt: "2024-06-06T09:52:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "435b01db-186a-45f3-a20b-333c3f29e546",
        body: "The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:47:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
      },
      {
        id: "f0925585-6abc-4d92-8655-3e307c9e52df",
        body: "The waves crashed against the shore, creating a soothing symphony of sound.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:49:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "cfd620a5-f6f9-42c9-9a4f-3800f07cf3e1",
        body: "The scent of blooming flowers wafted through the garden, creating a fragrant paradise.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
            name: "large-news.txt",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/large_news.txt",
            preview: "https://www.cloud.com/s/c218bo6kjuqyv66/large_news.txt",
            size: 6857142.857142857,
            createdAt: "2024-05-31T05:51:11.099Z",
            modifiedAt: "2024-05-31T05:51:11.099Z",
            type: "txt",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
            name: "nauru-6015-small-fighter-left-gender.psd",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/nauru-6015-small-fighter-left-gender.psd",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/nauru-6015-small-fighter-left-gender.psd",
            size: 6000000,
            createdAt: "2024-05-30T04:51:11.099Z",
            modifiedAt: "2024-05-30T04:51:11.099Z",
            type: "psd",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
            name: "tv-xs.doc",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/tv-xs.doc",
            preview: "https://www.cloud.com/s/c218bo6kjuqyv66/tv-xs.doc",
            size: 5333333.333333333,
            createdAt: "2024-05-29T03:51:11.099Z",
            modifiedAt: "2024-05-29T03:51:11.099Z",
            type: "doc",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
            name: "gustavia-entertainment-productivity.docx",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/gustavia-entertainment-productivity.docx",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/gustavia-entertainment-productivity.docx",
            size: 4800000,
            createdAt: "2024-05-28T02:51:11.099Z",
            modifiedAt: "2024-05-28T02:51:11.099Z",
            type: "docx",
          },
        ],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "3249f491-edde-441a-8706-0096600e94fb",
        body: "She gazed up at the night sky, marveling at the twinkling stars that dotted the darkness.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
        role: "Account Manager",
        email: "aditya_greenfelder31@gmail.com",
        name: "Lainey Davidson",
        lastActivity: "2024-06-01T06:52:14.377Z",
        address: "2089 Runolfsson Harbors Suite 886 - Chapel Hill, TX / 32827",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_6.jpg",
        phoneNumber: "955-439-2578",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "d9f21b1e-fc14-41e9-95eb-b5a5b5947c8c",
        body: "He carefully crafted a beautiful sculpture out of clay, his hands skillfully shaping the intricate details.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "d2f1c9c5-1552-4b90-bad4-48da3a2f0dd7",
        body: "The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "alway",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
        role: "Registered Nurse",
        email: "lenna_bergnaum27@hotmail.com",
        name: "Cristopher Cardenas",
        lastActivity: "2024-05-31T05:52:14.377Z",
        address: "279 Karolann Ports Apt. 774 - Prescott Valley, WV / 53905",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_7.jpg",
        phoneNumber: "226-924-4058",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "a5c17aa2-1d36-4371-9108-58f278e12f67",
        body: "The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "1c7ede67-9a28-4f27-8efa-7a03fae22918",
        body: "The waves crashed against the shore, creating a soothing symphony of sound.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2gr",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "alway",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
        role: "Registered Nurse",
        email: "lenna_bergnaum27@hotmail.com",
        name: "Cristopher Cardenas",
        lastActivity: "2024-05-31T05:52:14.377Z",
        address: "279 Karolann Ports Apt. 774 - Prescott Valley, WV / 53905",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_7.jpg",
        phoneNumber: "226-924-4058",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
        role: "Business Analyst",
        email: "luella.ryan33@gmail.com",
        name: "Melanie Noble",
        lastActivity: "2024-05-30T04:52:14.377Z",
        address: "96607 Claire Square Suite 591 - St. Louis Park, HI / 40802",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_8.jpg",
        phoneNumber: "552-917-1454",
      },
      {
        status: "offline",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
        role: "Creative Director",
        email: "joana.simonis84@gmail.com",
        name: "Chase Day",
        lastActivity: "2024-05-29T03:52:14.377Z",
        address: "9388 Auer Station Suite 573 - Honolulu, AK / 98024",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_9.jpg",
        phoneNumber: "285-840-9338",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
        role: "Financial Planner",
        email: "marjolaine_white94@gmail.com",
        name: "Shawn Manning",
        lastActivity: "2024-05-28T02:52:14.377Z",
        address: "47665 Adaline Squares Suite 510 - Blacksburg, NE / 53515",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_10.jpg",
        phoneNumber: "306-269-2446",
      },
      {
        status: "offline",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b11",
        role: "Event Coordinator",
        email: "vergie_block82@hotmail.com",
        name: "Soren Durham",
        lastActivity: "2024-05-27T01:52:14.377Z",
        address: "989 Vernice Flats Apt. 183 - Billings, NV / 04147",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_11.jpg",
        phoneNumber: "883-373-6253",
      },
    ],
    type: "GROUP",
    unreadCount: 2,
    messages: [
      {
        id: "93b629e1-29ed-4fc4-9cba-6d781f330b84",
        body: "The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-03T09:22:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "6774dfc4-ec9f-40d3-9b2f-d21771d649fd",
        body: "The waves crashed against the shore, creating a soothing symphony of sound.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-03T09:23:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
      },
      {
        id: "96a0d9b1-2372-494f-8c93-d04aaeea6d98",
        body: "The scent of blooming flowers wafted through the garden, creating a fragrant paradise.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-03T09:24:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b11",
      },
      {
        id: "5c364fbb-321b-4b1c-a0be-1fbffc5747fa",
        body: "She gazed up at the night sky, marveling at the twinkling stars that dotted the darkness.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-03T09:25:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
      },
      {
        id: "36239a78-ce03-4be7-a4ea-150bff3fbc09",
        attachments: [],
        body: "The professor delivered a captivating lecture, engaging the students with thought-provoking ideas.",
        contentType: "text",
        createdAt: "2024-06-03T09:26:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "bdc36005-7f64-4dfa-9ef4-59946d3932d8",
        body: "The hiker trekked through the dense forest, guided by the soft glow of sunlight filtering through the trees.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-03T11:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
      },
      {
        id: "bf09cde1-387f-4375-aa20-69f2ec939756",
        body: "The delicate butterfly gracefully fluttered from flower to flower, sipping nectar with its slender proboscis.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-03T11:52:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
        role: "Business Analyst",
        email: "luella.ryan33@gmail.com",
        name: "Melanie Noble",
        lastActivity: "2024-05-30T04:52:14.377Z",
        address: "96607 Claire Square Suite 591 - St. Louis Park, HI / 40802",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_8.jpg",
        phoneNumber: "552-917-1454",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "c7aa482c-35f3-474f-b621-6d2808d5c826",
        body: "The waves crashed against the shore, creating a soothing symphony of sound.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "961856dd-97f2-4c5a-8e5a-04641b5f6dbb",
        body: "The scent of blooming flowers wafted through the garden, creating a fragrant paradise.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "offline",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
        role: "Creative Director",
        email: "joana.simonis84@gmail.com",
        name: "Chase Day",
        lastActivity: "2024-05-29T03:52:14.377Z",
        address: "9388 Auer Station Suite 573 - Honolulu, AK / 98024",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_9.jpg",
        phoneNumber: "285-840-9338",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "3f6361be-c787-45ca-b21f-918c507f21fa",
        body: "The scent of blooming flowers wafted through the garden, creating a fragrant paradise.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "2861e98d-032d-46e1-8df7-e459d2a9e5e1",
        body: "She gazed up at the night sky, marveling at the twinkling stars that dotted the darkness.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
        role: "Financial Planner",
        email: "marjolaine_white94@gmail.com",
        name: "Shawn Manning",
        lastActivity: "2024-05-28T02:52:14.377Z",
        address: "47665 Adaline Squares Suite 510 - Blacksburg, NE / 53515",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_10.jpg",
        phoneNumber: "306-269-2446",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "3fb481e1-36b5-4ba2-8a21-77e7dfeff77e",
        body: "She gazed up at the night sky, marveling at the twinkling stars that dotted the darkness.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "48fff74c-c561-46ec-9f49-e9ba3532c966",
        body: "The professor delivered a captivating lecture, engaging the students with thought-provoking ideas.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.377Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3gr",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
        role: "Data Analyst",
        email: "ashlynn_ohara62@gmail.com",
        name: "Lucian Obrien",
        lastActivity: "2024-06-05T10:52:14.377Z",
        address: "1147 Rohan Drive Suite 819 - Burlington, VT / 82021",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_2.jpg",
        phoneNumber: "904-966-2836",
      },
      {
        status: "offline",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
        role: "Legal Counsel",
        email: "milo.farrell@hotmail.com",
        name: "Deja Brady",
        lastActivity: "2024-06-04T09:52:14.377Z",
        address: "18605 Thompson Circle Apt. 086 - Idaho Falls, WV / 50337",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_3.jpg",
        phoneNumber: "399-757-9909",
      },
      {
        status: "offline",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
        role: "Project Manager",
        email: "letha_lubowitz24@yahoo.com",
        name: "Reece Chung",
        lastActivity: "2024-06-02T07:52:14.377Z",
        address: "36901 Elmer Spurs Apt. 762 - Miramar, DE / 92836",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_5.jpg",
        phoneNumber: "990-588-5716",
      },
      {
        status: "online",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
        role: "UX/UI Designer",
        email: "violet.ratke86@yahoo.com",
        name: "Harrison Stein",
        lastActivity: "2024-06-03T08:52:14.377Z",
        address: "110 Lamar Station Apt. 730 - Hagerstown, OK / 49808",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_4.jpg",
        phoneNumber: "692-767-2903",
      },
    ],
    type: "GROUP",
    unreadCount: 0,
    messages: [
      {
        id: "ee50e355-e92b-4518-a75f-36c753c76c5d",
        body: "She eagerly opened the gift, her eyes sparkling with excitement.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1",
            name: "cover-2.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_3.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_3.jpg",
            size: 48000000,
            createdAt: "2024-06-06T11:51:11.098Z",
            modifiedAt: "2024-06-06T11:51:11.098Z",
            type: "jpg",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
            name: "design-suriname-2015.mp3",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/design_suriname_2015.mp3",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/design_suriname_2015.mp3",
            size: 24000000,
            createdAt: "2024-06-05T10:51:11.098Z",
            modifiedAt: "2024-06-05T10:51:11.098Z",
            type: "mp3",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
            name: "expertise-2015-conakry-sao-tome-and-principe-gender.mp4",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/expertise_2015_conakry_sao-tome-and-principe_gender.mp4",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/expertise_2015_conakry_sao-tome-and-principe_gender.mp4",
            size: 16000000,
            createdAt: "2024-06-04T09:51:11.098Z",
            modifiedAt: "2024-06-04T09:51:11.098Z",
            type: "mp4",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
            name: "money-popup-crack.pdf",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/money-popup-crack.pdf",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/money-popup-crack.pdf",
            size: 12000000,
            createdAt: "2024-06-03T08:51:11.098Z",
            modifiedAt: "2024-06-03T08:51:11.098Z",
            type: "pdf",
          },
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
            name: "cover-4.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_4.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_4.jpg",
            size: 9600000,
            createdAt: "2024-06-02T07:51:11.098Z",
            modifiedAt: "2024-06-02T07:51:11.098Z",
            type: "jpg",
          },
        ],
        createdAt: "2024-06-03T09:22:14.378Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "7aee7b4a-d733-4f17-a562-8e6aa385d098",
        body: "The old oak tree stood tall and majestic, its branches swaying gently in the breeze.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b6",
            name: "cover-6.jpg",
            path: "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_6.jpg",
            preview:
              "https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_6.jpg",
            size: 8000000,
            createdAt: "2024-06-01T06:51:11.098Z",
            modifiedAt: "2024-06-01T06:51:11.098Z",
            type: "jpg",
          },
        ],
        createdAt: "2024-06-03T09:23:14.378Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b2",
      },
      {
        id: "46af5aed-0cdf-4b21-b0fc-eccb519de078",
        body: "The aroma of freshly brewed coffee filled the air, awakening my senses.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b7",
            name: "large-news.txt",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/large_news.txt",
            preview: "https://www.cloud.com/s/c218bo6kjuqyv66/large_news.txt",
            size: 6857142.857142857,
            createdAt: "2024-05-31T05:51:11.099Z",
            modifiedAt: "2024-05-31T05:51:11.099Z",
            type: "txt",
          },
        ],
        createdAt: "2024-06-03T09:24:14.378Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b3",
      },
      {
        id: "a5003193-d360-4619-a83a-0c40fe7622ed",
        body: "The children giggled with joy as they ran through the sprinklers on a hot summer day.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b8",
            name: "nauru-6015-small-fighter-left-gender.psd",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/nauru-6015-small-fighter-left-gender.psd",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/nauru-6015-small-fighter-left-gender.psd",
            size: 6000000,
            createdAt: "2024-05-30T04:51:11.099Z",
            modifiedAt: "2024-05-30T04:51:11.099Z",
            type: "psd",
          },
        ],
        createdAt: "2024-06-03T09:25:14.378Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5",
      },
      {
        id: "358951d3-0351-4a10-9283-62f6faf7a5a1",
        body: "He carefully crafted a beautiful sculpture out of clay, his hands skillfully shaping the intricate details.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b9",
            name: "tv-xs.doc",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/tv-xs.doc",
            preview: "https://www.cloud.com/s/c218bo6kjuqyv66/tv-xs.doc",
            size: 5333333.333333333,
            createdAt: "2024-05-29T03:51:11.099Z",
            modifiedAt: "2024-05-29T03:51:11.099Z",
            type: "doc",
          },
        ],
        createdAt: "2024-06-03T09:26:14.378Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "60ce9e28-8522-438c-946f-b9760b40dfcc",
        body: "The concert was a mesmerizing experience, with the music filling the venue and the crowd cheering in delight.",
        contentType: "text",
        attachments: [
          {
            id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b10",
            name: "gustavia-entertainment-productivity.docx",
            path: "https://www.cloud.com/s/c218bo6kjuqyv66/gustavia-entertainment-productivity.docx",
            preview:
              "https://www.cloud.com/s/c218bo6kjuqyv66/gustavia-entertainment-productivity.docx",
            size: 4800000,
            createdAt: "2024-05-28T02:51:11.099Z",
            modifiedAt: "2024-05-28T02:51:11.099Z",
            type: "docx",
          },
        ],
        createdAt: "2024-06-03T11:52:14.378Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b4",
      },
    ],
  },
  {
    id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b11",
    participants: [
      {
        status: "online",
        id: "8864c717-587d-472a-929a-8e5f298024da-0",
        role: "admin",
        email: "demo@minimals.cc",
        name: "Jaydon Frankie",
        lastActivity: "2024-06-06T11:52:14.376Z",
        address: "90210 Broadway Blvd",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_25.jpg",
        phoneNumber: "+40 777666555",
      },
      {
        status: "offline",
        id: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b11",
        role: "Event Coordinator",
        email: "vergie_block82@hotmail.com",
        name: "Soren Durham",
        lastActivity: "2024-05-27T01:52:14.377Z",
        address: "989 Vernice Flats Apt. 183 - Billings, NV / 04147",
        avatarUrl:
          "https://api-prod-minimal-v510.vercel.app/assets/images/avatar/avatar_11.jpg",
        phoneNumber: "883-373-6253",
      },
    ],
    type: "ONE_TO_ONE",
    unreadCount: 0,
    messages: [
      {
        id: "f4548b8f-dce2-4c13-a938-6596c0a8e987",
        body: "The professor delivered a captivating lecture, engaging the students with thought-provoking ideas.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.378Z",
        senderId: "8864c717-587d-472a-929a-8e5f298024da-0",
      },
      {
        id: "4c2edb48-9bbe-48c5-beb6-5f8169318584",
        body: "The hiker trekked through the dense forest, guided by the soft glow of sunlight filtering through the trees.",
        contentType: "text",
        attachments: [],
        createdAt: "2024-06-06T11:51:14.378Z",
        senderId: "e99f09a7-dd88-49d5-b1c8-1daf80c2d7b11",
      },
    ],
  },
];
